import { render } from "./UTAKHC.vue?vue&type=template&id=dddc7828"
import script from "./UTAKHC.vue?vue&type=script&lang=js"
export * from "./UTAKHC.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/UTAKHC.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dddc7828"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dddc7828', __exports__)) {
    console.log('reload')
    api.reload('dddc7828', __exports__)
  }
  
  module.hot.accept("./UTAKHC.vue?vue&type=template&id=dddc7828", () => {
    console.log('re-render')
    api.rerender('dddc7828', render)
  })

}


export default __exports__